<script setup>
// Dzień i godzina wpisu. `draft` to wspólny obiekt szkicu — mutujemy jego pola
// wprost, żeby nie przepisywać dwudziestu v-modeli przez cały modal.
import { computed } from 'vue';
import DaySelect from '@/components/v2/add/day-select.vue';
import TimeInput from '@/components/v2/time-input.vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
    draft: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    // Zadanie może nie mieć godziny — wtedy trafia do „Bez godziny".
    timeOptional: { type: Boolean, default: false },
    // Puste = „Godzina" w języku aplikacji.
    timeLabel: { type: String, default: '' },
});

const { t } = useI18n();

// „wstecz" = wskazana chwila już minęła; sama informacja, nie pole API.
const isPast = computed(() => {
    if (!props.draft.time) return false;
    const [h, m] = props.draft.time.split(':').map(Number);
    const at = new Date(props.draft.day);
    at.setHours(h || 0, m || 0, 0, 0);
    return at.getTime() < Date.now();
});
</script>

<template>
    <div class="grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-3">
        <DaySelect :draft="draft" />

        <div class="sm:w-[168px]">
            <label class="v2-label" for="v2-time">
                {{ timeLabel || t('entry.fields.time') }}<span v-if="timeOptional" class="text-[#B8B0A3]"> {{ t('entry.when.optional') }}</span>
            </label>

            <div v-if="timeOptional && !draft.withTime" class="flex items-center h-[38px]">
                <button
                    type="button"
                    class="text-[12.5px] font-semibold text-[#B5643C] hover:text-[#8E4B2C] transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#C0764B] rounded"
                    @click="draft.withTime = true"
                >
                    {{ t('entry.when.setTime') }}
                </button>
            </div>

            <div v-else class="relative">
                <TimeInput id="v2-time" v-model="draft.time" :invalid="!!errors.time" />
                <span
                    v-if="isPast"
                    class="absolute right-8 top-[19px] -translate-y-1/2 px-1.5 py-0.5 rounded bg-[#F2ECE1] text-[10.5px] text-[#8A8378] pointer-events-none"
                >{{ t('entry.when.past') }}</span>
            </div>

            <button
                v-if="timeOptional && draft.withTime"
                type="button"
                class="mt-1.5 text-[11.5px] text-[#A29A8E] hover:text-[#211E1A] transition-colors"
                @click="draft.withTime = false"
            >
                {{ t('entry.when.noTime') }}
            </button>
            <p v-if="errors.time" class="text-[11.5px] text-[#B5643C] mt-1">{{ errors.time }}</p>
        </div>
    </div>
</template>
